import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BaiduMap from "vue-baidu-map-3x";
import moment from 'moment';
import {get, post} from './utils/http'
import api from './utils/api'
import Print from 'vue-print-nb'
import './styles/global-table.less'
import {
  Button,
  Layout,
  Menu,
  Table,
  Input,
  Modal,
  Form,
  Radio,
  Checkbox,
  Select,
  Row,
  Col,
  statistic,
  DatePicker,
  TreeSelect,
  Cascader,
  message,
  popconfirm,
  Tag,
  Tree,
  InputNumber,
  List,
  Pagination
} from "ant-design-vue";


var app=createApp(App)
app.config.globalProperties.Get=get 
app.config.globalProperties.Post=post 
app.config.globalProperties.Api=api

const userMenus = localStorage.getItem('userMenus')
if(userMenus) {
  store.commit('SETMENU', JSON.parse(userMenus))
  store.commit('ADDROUTES')
}

app
  .use(store)
  .use(router)
  .use(Button)
  .use(Layout)
  .use(Menu)
  .use(Table)
  .use(Input)
  .use(Modal)
  .use(Form)
  .use(Radio)
  .use(Checkbox)
  .use(Select)
  .use(Col)
  .use(Row)
  .use(DatePicker)
  .use(statistic)
  .use(moment)
  .use(TreeSelect)
  .use(Cascader)
  .use(message)
  .use(popconfirm)
  .use(Print)
  .use(Tag)
  .use(Tree)
  .use(InputNumber)
  .use(List)
  .use(Pagination)
  .use(BaiduMap, { ak: "oji7kgM4h9m8uUQm0N3VoAKvL5G44z2u" })
  .mount("#app");
  


